import {
  SELECT_DOCTOR_ID,
  LEAVE_START_DATE,
  LEAVE_END_DATE,
  SELECT_REMARK,
  FETCH_DOCTOR_LEAVES,
  FETCH_DOCTOR_LEAVES_SUCCESS,
  DOCTOR_LEAVE_ACTION_SUCCESS,
  DOCTOR_LEAVE_SUBMIT_FORM,
  DOCTOR_LEAVE_EDIT,
  DOCTOR_LEAVE_DIALOG_BOX_STATUS,
  DOCTOR_LEAVE_DELETE,
  DOCTOR_LEAVE_SET_DELETE_ID,
  DOCTOR_LEAVE_EDIT_SUBMIT_FORM,
} from "../constants/doctorLeave.constants";

export const selectDoctorID = (doctor_id) => {
  return {
    type: SELECT_DOCTOR_ID,
    doctor_id: doctor_id,
  };
};

export const selectStartDate = (start_date) => {
  return {
    type: LEAVE_START_DATE,
    start_date: start_date,
  };
};

export const selectEndDate = (end_date) => {
  return {
    type: LEAVE_END_DATE,
    end_date: end_date,
  };
};

export const selectRemark = (remark) => {
  return {
    type: SELECT_REMARK,
    remark: remark,
  };
};

export const getDoctorLeaveSuccess = (doctor_leaves) => {
  return {
    type: FETCH_DOCTOR_LEAVES_SUCCESS,
    doctor_leaves: doctor_leaves,
  };
};

export const doctorLeaveActionSuccess = (doctor_leaves) => {
  return {
    type: DOCTOR_LEAVE_ACTION_SUCCESS,
    doctor_leaves: doctor_leaves,
  };
};

export const onSubmitDoctorLeaveForm = (new_doctor_leaves_data) => {
  return {
    type: DOCTOR_LEAVE_SUBMIT_FORM,
    new_doctor_leaves_data: new_doctor_leaves_data,
  };
};

export const doctorLeaveEdit = (doctor_leave_id) => {
  return {
    type: DOCTOR_LEAVE_EDIT,
    doctor_leave_id: doctor_leave_id,
  };
};

export const changeDoctorLeaveDialogBoxStatus = (status) => {
  return {
    type: DOCTOR_LEAVE_DIALOG_BOX_STATUS,
    status: status,
  };
};

export const doctorLeaveDelete = (doctor_leave_id) => {
  return {
    type: DOCTOR_LEAVE_DELETE,
    doctor_leave_id: doctor_leave_id,
  };
};

export const changeDoctorLeaveDeleteId = (delete_id) => {
  return {
    type: DOCTOR_LEAVE_SET_DELETE_ID,
    delete_id: delete_id,
  };
};

export const onSubmitDoctorLeaveEditForm = (doctor_leave_data, page) => {
  return {
    type: DOCTOR_LEAVE_EDIT_SUBMIT_FORM,
    doctor_leave_data: doctor_leave_data,
    page: page,
  };
};

export const getDoctorLeaves = (page) => {
  return {
    type: FETCH_DOCTOR_LEAVES,
    page: page,
  };
};
